import { useData, withDefault } from "@faedev/editor-utils";
import constants from "src/constants";
import graphQLClient from "src/graphQL";
import { partners } from "src/queries/partners";

const defaultWhere = {
  blocked: false,
  private: false,
};

const homepageWhere = {
  blocked: false,
  private: false,
  id: constants.List.hpPartners,
};

export default function getDataPartner(
  slug?: string | null | undefined,
  lang?: string | null | undefined
) {
  return useData(
    () =>
      fetch(`${constants.Paths.apiUrl}/partners/${slug}`).then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error("API Error");
        }
      }),
    { _locale: withDefault(lang, constants.Locales._default.lang) }
  );
}

export async function getDataPartners(): Promise<any> {
  const { data } = await graphQLClient.query({
    query: partners,
    variables: { sort: "slug:ASC", where: defaultWhere },
    errorPolicy: "all",
  });

  return data.partners;
}
